import classnames from "classnames";

import styles from "./PopupImage.module.scss";

type PopupImageProps = {
  alt?: string;
  imageSrc: string;
  isAgeVerificationInProgress?: boolean;
  dataTestId?: string;
};

export const PopupImage = ({ alt = "", imageSrc, isAgeVerificationInProgress, dataTestId }: PopupImageProps) => (
  <div
    className={classnames(styles.wrapper, {
      [styles.wrapperBlurred]: isAgeVerificationInProgress,
    })}
    data-testid={dataTestId}
  >
    <img className={styles.mainImage} src={imageSrc} alt={alt} loading="lazy" />
  </div>
);
